import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from '@roomex/rx-components';
import { AuthConfigService } from '@rx-applications/shared/auth/data-access';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'rx-applications-contact-instructions',
  standalone: true,
  imports: [CommonModule, IconSvgComponent, TranslocoDirective],
  templateUrl: './contact-instructions.component.html',
  styleUrl: './contact-instructions.component.scss',
  providers: [translationProvider],
})
export class ContactInstructionsComponent {
  readonly authConfigService = inject(AuthConfigService);
  readonly config = this.authConfigService.config;
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  get showContactInfo(): boolean {
    return !!(this.config?.loginShowContactInfo && this.config?.loginContactEmail);
  }

  contactInstructionsHtmlParams(): { name: string | undefined; email: string } {
    return {
      name: this.config?.loginContactName,
      email: this.config!.loginContactEmail,
    };
  }
}
